import { useAxiosInstance } from '@gov-nx/api/axios';
import { logger } from '@gov-nx/api/logger';
import { authNiaRegisterQuery } from '@gov-nx/api/queries/authQuery';
import type { ApiCallback } from '@gov-nx/core/hooks/Api/useApiCallback';
import { useAuthStore } from '@gov-nx/store/auth/store';
import { delay } from '@gov-nx/utils/common/Time/delay';

export const useAuthNiaRegisterQuery = () => {
	const setAccessToken = useAuthStore('setAccessToken');
	const { axiosInstance } = useAxiosInstance();

	const fetch = async (
		accessToken: string,
		{ reject, resolve }: ApiCallback<undefined, Error>
	): Promise<void> => {
		try {
			logger('before await authNiaRegisterQuery accessToken', [accessToken]);
			const instance = await authNiaRegisterQuery(
				axiosInstance,
				accessToken as string
			);
			logger('before setAccessToken(instance.access_token)', [
				instance.access_token,
			]);
			setAccessToken(instance.access_token);
			await delay(200);
			logger('before resolve && resolve()', []);
			resolve?.();
		} catch (e) {
			logger('before reject && reject(e as Error)', [(e as Error).toString()]);
			reject?.(e as Error);
		}
	};

	return { fetch };
};
